import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const UploadProfileImage = styled(Box)`
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 30px;
  flex-direction: column;
  position: relative;
  &:hover {
    background-color: unset;
  }
  .user-name {
    font-weight: "bold";
    margin-top: 10px;
  }
  .profile-action-button {
    margin-top: 15px;
    display: flex;
    gap: 20px;
  }
  .error-message {
    font-size: 12px;
    color: red;
    margin-top: 10px;
  }
  .avatar {
    width: 100px;
    height: 100px;
    background-color: #0175be;
    span {
      font-size: 50px;
    }
  }
  @media (max-width: 768px) {
    .user-name {
      font-size: 18px;
    }
    .information-header {
      font-size: 19px;
    }
  }
`;

export const ProfileDetailsBox = styled(Box)`
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  height: fit-content;
  border-radius: 10px;
  padding: 25px;
  margin: 17px 15px;
  .information-header {
    font-weight: bold;
    margin-bottom: 20px;
  }
  @media (max-width: 768px) {
    margin: 15px 5px;
    .information-header {
      font-size: 19px;
    }
  }
`;

export const AdminProfileImageBox = styled(Box)`
  width: 100%;
  height: 192px;
  margin: 0 auto;
  .image-box {
    width: 100%;
    border-radius: 12px;
    height: 100%;
  }
  .dashboard-icon {
    width: 100%;
    height: 168px;
  }
`;

export const DigitalSignatureContainer = styled("div")`
  display: flex;
  height: 192px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const UploadSignature = styled("div")(
  ({ theme }) => `
  border: 1px dashed ${theme.palette.mode === "light" ? "#000" : "#FFF"};
  background-color: ${theme.palette.mode === "light" ? "#f1f1f1" : "#696969"};
  display: flex;
  justify-content: center;
  align-items: center;  
  height: 130px;
  width: 200px;
  margin: 0 auto;
  text-align: center;
`
);
